module.exports = __webpack_public_path__ + "static/media/BrixSans-Light-Italic.a902584a.ttf";